export const BLUR_MAC_ADDRESS_ACTION = "mac-address/BLUR_MAC_ADDRESS_ACTION";

export default function blurMacAddressAction() {
  return {
    "payload": {},
    "type": BLUR_MAC_ADDRESS_ACTION
  };
}
